const TIMEOUT = 1000;
export const flyoutTransition = {
    duration: (TIMEOUT / 1000) * 1,
    type: 'tween',
    ease: [0.5, 0, 0, 1],
    precision: 0.01,
};
//# sourceMappingURL=config.js.map